import { useEffect, useState } from 'react';

import { BOOT_HINT_ROTATE_MS } from './bootStatus';

/**
 * 掛載後經過的毫秒數 —— 每 {@link BOOT_HINT_ROTATE_MS} 更新一次。
 *
 * ⚠️ **R317 起改用 `setInterval`**:原本只有兩個切換點(4s / 12s)所以掛兩顆
 * `setTimeout` 就夠;現在 hint 是 10 句輪播,要持續 tick 才會動。
 *
 * ⚠️ **一定要在 unmount 清掉**:沒清的話 jsdom 拆掉之後 interval 還會醒來呼叫
 * `setState` —— 那正是 R315 那顆 `justDropped` 計時器的死法(所有 test 綠但 exit 1)。
 *
 * ⚠️ 回的是**真實經過時間**而不是 tick 次數:分頁被切到背景時瀏覽器會節流 interval,
 * 用次數乘間隔會慢慢失準,`Date.now()` 差值不會。
 */
export function useBootElapsedMs(): number {
  const [elapsedMs, setElapsedMs] = useState(0);
  useEffect(() => {
    const startedAt = Date.now();
    const id = setInterval(() => setElapsedMs(Date.now() - startedAt), BOOT_HINT_ROTATE_MS);
    return () => clearInterval(id);
  }, []);
  return elapsedMs;
}
